import { createContext } from "react";
import { AuthenticatedState } from "../types";

export const AuthenticatedContext = createContext<
  AuthenticatedState | undefined
>(undefined);
